<template>
  <div>
    <bar-chart :chart-data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'

export default {
  name: 'OrderChart',
  components: {
    BarChart: Bar
  },
  data () {
    return {
      chartData: {
        labels: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        datasets: [
          {
            label: 'Количество заказов',
            backgroundColor: '#1976D2',
            data: [40, 55, 30, 70, 90, 120, 150, 130, 100, 95, 110, 145]
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    }
  }
}
</script>

<style scoped>
div {
  height: 300px;
}
</style>
